
let url_config = ""
if(process.env.NODE_ENV === 'development'){
	// 开发环境
	// url_config = 'http://192.168.20.104:9091/'
	url_config = 'https://lhdx.gxsentu.net/school_share2/'
}else{
    // 生产环境
	url_config = 'https://lhdx.gxsentu.net/school_share2/'
	// url_config = 'http://192.168.20.104:9091/'
}
export default url_config

